export default [
  {
    label: "Poetry",
    value: "Poetry"
  },
  {
    label: "Prose Nonfiction",
    value: "Prose Nonfiction"
  },
  {
    label: "Prose Fiction",
    value: "Prose Fiction"
  },
  {
    label: "Play or Drama",
    value: "Play or Drama"
  },
  {
    label: "Mythology",
    value: "Mythology"
  }
];
